<template>
	<o-section
		class="temp-worker-rate"
		title="Performance du candidat">
		<o-card>
			<div
				v-if="setup.self.isAgency()"
				class="temp-worker-rate__title">
				Globale (ETT) :
				<o-rate
					v-model="rating"
					font-icon="icon-interface-favorite-star-bold"
					disabled
					color="warning"
					:number-of-rates="numberOfRating"/>
			</div>

			<hr class="mv-sm">

			<div
				class="temp-worker-rate__title">
				Votre appréciation :
				<o-rate
					v-model="setup.authorRate"
					font-icon="icon-interface-favorite-star-bold"
					color="warning"/>
			</div>
		</o-card>
	</o-section>
</template>

<script setup lang="ts">
import TempWorkerRatingSetupService from '@/setup/temp-worker/TempWorkerRatingSetupService';
const emits = defineEmits<{(e: 'rate-updated'): void}>();
const props = defineProps(TempWorkerRatingSetupService.props);
const setup = new TempWorkerRatingSetupService(props, emits);
</script>

<style scoped lang="less">
.temp-worker-rate {
	&__title {
		font-size: 0.9rem;
		font-weight: 600;
		color: var(--grey-darker);
		margin-bottom: 0;
		line-height: 1;
		display: flex;
		justify-content: space-between;
	}
}
</style>
